// Import CSS với theme system
import './css/input.css';

// Import theme manager
import themeManager from './utils/theme-manager';

// Import other dependencies
import 'jquery-validation';
import 'jquery-validation/dist/localization/messages_ja';

// Initialize theme khi app khởi động
document.addEventListener('DOMContentLoaded', () => {
    themeManager.init();
});
